// Ver docs/migracao/decisoes.md (E.2): o legado monkey-patcha
// Date.prototype.toJSON para serializar em hora local sem "Z" — reaplicar
// isso envenenaria o app inteiro. Em vez de deixar um Date vazar para
// JSON.stringify, construímos a string "yyyy-MM-ddTHH:mm:ss" já na fronteira.
export function toLocalDateTimeString(date: string, endOfDay = false): string {
  return `${date}T${endOfDay ? "23:59:59" : "00:00:00"}`;
}

// Format-as-you-type simples para um campo isolado — não é o <CpfCnpjInput>
// genérico previsto pra Fase 5 (quando Instituição trouxer CPF e CNPJ juntos
// e várias telas repetirem a mesma máscara). Uma única ocorrência de CNPJ e
// uma de CEP não justificam esse componente ainda.
export function formatCnpj(value: string): string {
  const digits = value.replace(/\D/g, "").slice(0, 14);
  return digits
    .replace(/^(\d{2})(\d)/, "$1.$2")
    .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
    .replace(/\.(\d{3})(\d)/, ".$1/$2")
    .replace(/(\d{4})(\d)/, "$1-$2");
}

export function formatCep(value: string): string {
  const digits = value.replace(/\D/g, "").slice(0, 8);
  return digits.replace(/^(\d{5})(\d)/, "$1-$2");
}

// Campo date-only (sem hora) vindo do backend como "yyyy-MM-dd..." — extrai
// os componentes direto da string, sem passar por `Date`, pra não sofrer o
// shift de fuso que um `new Date("yyyy-MM-dd")` (interpretado como UTC
// meia-noite) causaria ao formatar em horário de Brasília (ver E.2/E.6do
// plano: o legado tem um dateFormatter que soma o offset de propósito pra
// desfazer exatamente esse shift — aqui evitamos o problema não usando Date).
/** "yyyy-MM-dd" de hoje, no fuso local — mesmo cuidado do E.2: nunca via Date.toISOString(). */
export function hojeStr(): string {
  return hojeMaisDias(0);
}

/** "yyyy-MM-dd" de hoje + N dias, no fuso local. Porte de `Date.now().addDays(n)`
 * (extensão Datejs) do legado — sem instanciar a lib, só aritmética de calendário. */
export function hojeMaisDias(dias: number): string {
  const d = new Date();
  d.setDate(d.getDate() + dias);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

export function formatDateBr(value?: string | null): string {
  if (!value) return "";
  const [y, m, d] = value.slice(0, 10).split("-");
  if (!y || !m || !d) return "";
  return `${d}/${m}/${y}`;
}

export function formatDateHoraBr(value?: string | null): string {
  if (!value) return "";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  return new Intl.DateTimeFormat("pt-BR", { dateStyle: "short", timeStyle: "short" }).format(d);
}

const MESES_ABREV = ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"];

/** "yyyy-MM" (ou "yyyy-MM-dd...") → "Mmm/aaaa". Porte de mesAnoFormatter() do
 * overview legado, direto da string (E.2: nunca via Date). */
export function formatMesAno(value?: string | null): string {
  if (!value) return "";
  const [y, m] = value.split("-");
  const mes = MESES_ABREV[Number(m) - 1];
  return y && mes ? `${mes}/${y}` : "N/I";
}

const moeda = new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" });

/** Porte de FormataDecimal() (static/js/Geral.js) com o "R$" que o template concatenava; nulo vira R$ 0,00. */
export function formatMoeda(value?: number | null): string {
  return moeda.format(value ?? 0);
}
